import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the Test Case API
 */
export class TestCaseService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getTestCases() {		
		var nodes = await this.makeGETRequest('/api/service/tests');		
		return nodes;
	}
	
	async runTest(testClassName, parameters) {	
		var result = await this.makePUTRequest('/api/service/tests/' + testClassName + '/run', parameters);
		return result;
	}	
	
	
};
